module.exports = __webpack_public_path__ + "7a845b3ac9afa60ac7923a87b2f2d995.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/spaceship.png
// module id = 2611
// module chunks = 0